import { render, staticRenderFns } from "./AudienceGroupLayout.vue?vue&type=template&id=dbd85102"
import script from "./AudienceGroupLayout.vue?vue&type=script&lang=js"
export * from "./AudienceGroupLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports